import { ticketBodyPreview } from '../../utils/ticketTitle';

export default function TicketBodyPreview({ ticket, style }) {
  const preview = ticketBodyPreview(ticket);
  if (!preview) return null;
  return (
    <p style={{ fontSize: 12, color: '#64748b', margin: '4px 0 6px', lineHeight: 1.6, ...style }}>
      {preview}
    </p>
  );
}
